import styled from 'styled-components';

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 99;
  button {
    gap: 5px;
  }
`;

export const StyledContent = styled.div`
  // min-width: calc(100% - 284px);
  // max-width: calc(100% - 284px);
  flex: 1;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #f1f3f5;
  background-color: #fff;
  height: ${({ isStaticTemplate }) => (isStaticTemplate ? '100%' : 'calc(100vh - 310px)')};
  overflow: auto;
`;

export const StyledSideber = styled.div`
  position: relative;
  .sidebar {
    position: sticky;
    top: 16px;
    min-width: 272px;
    max-width: 272px;
    padding: 24px 12px;
    border-radius: 4px;
    border: 1px solid #f1f3f5;
    background: #fff;
    overflow-y: auto;
    height: ${({ isStaticTemplate }) => (isStaticTemplate ? '75vh' : 'calc(100vh - 310px)')};
    transition: 0.4s ease-in-out all;

    &.collapsed {
      min-width: 68px !important;
      max-width: 68px !important;
    }

    .navigation {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      justify-content: space-between;
      padding: 0 8px;

      p {
        color: #495057;
        font-size: 16px;
        line-height: 22px;
        transition: 0.4s ease-in-out all;
        transition: 0.2s ease-in-out opacity;
        opacity: 0;
        width: 0;
        height: 0;

        &.expanded {
          opacity: 1;
          width: auto;
          height: auto;
          transition: 2s ease-in-out opacity;
        }
      }

      button {
        padding: 0;
        border: none;
        display: flex;
      }
    }
  }
`;

export const Wrapper = styled.div`
  background-color: #f8f9fa;
  padding: 16px;

  .container {
    display: flex;
    margin-top: 12px;
    gap: 12px;
  }

  .breadcrumb {
    margin-bottom: 20px;
  }

  .rg-cell {
    border-color: #f1f3f5 !important;
    padding: 0 !important;
    &.rg-header-cell {
      padding: 11px 8px !important;
      font-size: 12px;
      line-height: 17px;
      background: #f8f9fa !important;
      white-space: inherit;
    }
  }

  .badge {
    margin: 10px 16px;
  }
`;

export const WarngingBadgeStyled = styled.div`
  background-color: #e7f0ff;
  padding: 4px 0 4px 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 4px;

  // margin: 10px 16px;
  max-width: 1040px;

  p {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: #2b313d;
  }

  button {
    margin-left: 5px;
    margin-top: 2px;
  }
`;

export const TableStyle = styled.div`
  width: 100%;
  overflow: auto;
  padding-bottom: 8px;
  margin-bottom: 12px;
  /* &::-webkit-scrollbar {
//    display: none;
  } */
`;

export const ErrorList = styled.div`
  border-radius: 4px;
  background: #ffe9e9;
  padding: 12px;
  display: flex;
  gap: 2px;
  margin-bottom: 12px;
  .body {
    .header {
      display: flex;
      align-items: center;
      gap: 4px;
      .title {
        color: #5c5d61;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
      }
      .status {
        color: #fff;
        font-size: 13px;
        font-weight: 500;
        line-height: 20px;
        border-radius: 4px;
        padding: 0 4px;
        height: 20px;
        width: fit-content;
      }
    }
    ul {
      margin: 0;
      margin-top: 8px;
      padding-left: 15px;
      .underline {
        text-decoration: underline;
      }
      display: flex;
      flex-direction: column;
      gap: 4px;
      li {
        color: #5c5d5e;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
      }
    }
  }
`;

export const TableTitle = styled.div`
  color: #2b313d;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 8px;
`;

export const TableFooter = styled.div`
  display: flex;
  justify-content: end;
  margin-top: -15px;
  gap: 10px;
`;

export const TableSubtitle = styled.div`
  color: #2b313d;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 8px;
  margin-top: 8px;
`;

export const Title = styled.h1`
  color: #2b313d;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  margin-bottom: 8px;
  margin-top: 8px;
  text-align: center;
`;
